// On touch devices, keep the "show second photo" preview on first touch,
// and make sure the first tap always opens the product page. Some mobile
// browsers require a second tap on links that have hover styles (the first
// tap only previews the hover state); registering a real click listener on
// these links is what stops that behavior.
if (window.matchMedia('(pointer: coarse)').matches) {
  document.addEventListener('touchstart', (event) => {
    const figure = event.target.closest('.product-card__figure');

    document.querySelectorAll('.product-card__figure--touch-active').forEach((activeFigure) => {
      if (activeFigure !== figure) {
        activeFigure.classList.remove('product-card__figure--touch-active');
      }
    });

    if (figure) {
      figure.classList.add('product-card__figure--touch-active');
    }
  }, { passive: true });
}

document.addEventListener('click', (event) => {
  if (event.target.closest('.product-card__figure a, .product-card__title a')) {
    // Intentionally empty: the presence of this listener is what matters.
  }
});
